"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = require("styled-components");

var _cssReset = _interopRequireDefault(require("./cssReset"));

var _markdownStyles = _interopRequireDefault(require("./markdownStyles"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/**
 * GlobalStyle is a globally injected style sheet.
 * ALL declarations will be applied globally, unless its ignore flag is set.
 * If any declaration reaches deeply or causes indirection, please document it thoroughly.
 * 
 * @param {boolean} ignoreCSSReset - Setting this will cause GlobalStyle to not reset CSS.
 * @param {boolean} ignoreMarkdownStyles - Setting this will cause GlobalStyle to not override MD.
 */
var GlobalStyle = (0, _styledComponents.createGlobalStyle)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"])), function (props) {
  return props.ignoreCSSReset ? null : _cssReset["default"];
}, function (props) {
  return props.ignoreMarkdownStyles ? null : _markdownStyles["default"];
});
var _default = GlobalStyle;
exports["default"] = _default;